export default {
  ext_id: {
    label: 'Salon ID',
    required: true,
    valueKeys: ['__tmp', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'salon-id-invalid',
        alertLevel: 'critical',
      },
    ],
    // lookup: {
    //   mapper: '',
    // },
  },
  n: {
    label: 'Salon Name',
    required: true,
    valueKeys: ['$setOnInsert', 'n'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'salon-name-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  ext_salon_str1: {
    label: 'Salon Street 1',
    required: false,
    valueKeys: ['address', 'str1'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'address-invalid',
        alertLevel: 'warning',
      },
    ],
  },
  ext_salon_str2: {
    label: 'Salon Street 2',
    required: false,
    valueKeys: ['address', 'str2'],
    filters: ['trim'],
    validators: [],
  },
  ext_salon_city: {
    label: 'Salon City',
    required: false,
    valueKeys: ['address', 'city'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'address-invalid',
        alertLevel: 'warning',
      },
    ],
  },
  ext_salon_postal: {
    label: 'Salon Postal',
    required: false,
    valueKeys: ['address', 'postal'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'address-invalid',
        alertLevel: 'warning',
      },
    ],
  },
  ext_salon_state: {
    label: 'Salon State',
    required: false,
    valueKeys: ['address', 'state'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'address-invalid',
        alertLevel: 'warning',
      },
    ],
  },
  ext_salon_country: {
    label: 'Salon Country',
    required: false,
    valueKeys: ['address', 'country'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'address-invalid',
        alertLevel: 'warning',
      },
    ],
  },
  phone: {
    label: 'Salon Phone',
    required: false,
    valueKeys: ['$set', 'phone'],
    filters: ['trim'],
    validators: [],
  },
  contact: {
    label: 'Salon Contact',
    required: false,
    valueKeys: ['$set', 'contact'],
    filters: ['trim'],
    validators: [],
  },
  // below removed because it was Distributor specific but saved as global
  // ext_salon_region: {
  //   label: 'Salon Region Level 1',
  //   required: false,
  //   valueKeys: ['$set', 'data.rgn_l1'],
  //   filters: ['trim'],
  //   validators: [],
  // },
  // ext_salon_subregion: {
  //   label: 'Salon Region Level 2',
  //   required: false,
  //   valueKeys: ['$set', 'data.rgn_l2'],
  //   filters: ['trim'],
  //   validators: [],
  // },
};



// WEBPACK FOOTER //
// ./src/configs/etl/salons/salonsColumnsConfig.js